<template>
	<div>
		<div id="g_id_onload"
		     v-bind:data-client_id="client_id"
		     data-context="signin"
		     data-ux_mode="popup"
		     data-callback="callback"
		     data-nonce=""
		     data-auto_select="true"
		     data-itp_support="true">
		</div>
		
		<div class="g_id_signin mySetting"
		    style="opacity: 0;"
		     data-type="standard"
		     data-shape="rectangular"
		     data-theme="outline"
		     data-text="signin_with"
		     data-size="large"
		     data-logo_alignment="center">
		</div>
	</div>
</template>

<script>
	window.callback = function(response) {
	  console.log(response); // 处理 Google 登录返回的数据
	  
	   if (window.vueInstance) {
	      window.vueInstance.handleLoginResponse(response);
	    }
	
	};
	export default{
		data(){
			return{
				client_id:localStorage.getItem('client_id'),
				credential:'',
			}
		},
		mounted() {
			const script = document.createElement('script');
			script.src = "https://accounts.google.com/gsi/client";
			script.async = true;
			document.head.appendChild(script);
					
			script.onload = () => {
			  console.log('Google API script loaded',this.client_id);
			  
			};
					
			script.onerror = (error) => {
			  console.error('Error loading script', error);
			};
			window.vueInstance = this;
		},
		methods:{
			handleLoginResponse(response){
				console.log("===",response);
				this.credential = response.credential
				this.$http.api('user/thirdBinding', {
					type:'google',
					credential:this.credential
				}).then(res=>{
					this.$message.success(this.$t('common.operationSuccessful') )
					this.$emit('ok')
				})
				 
			},
		}
	}
</script>

<style>
	::v-deep.mySetting .nsm7Bb-HzV7m-LgbsSe{
		/* position: absolute !important;
		width: 100%;
		height: 58px;
		z-index: 99; */
		opacity: 0;
	}
</style>